import { computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { useSurveyStore } from "../survey";
import { useAccountsStore, accountLabel } from "../../accounts";
import { useSurveyCreditsStore } from "./surveyCredits";

export const useSurveyAccountStore = defineStore("surveyAccount", () => {
  // imported stores
  const surveyStore = useSurveyStore();
  const accountsStore = useAccountsStore();
  const { survey } = storeToRefs(surveyStore);
  const { accounts } = storeToRefs(accountsStore);

  const currentAccountId = computed(() => survey.value?.account_id?.toString());
  const updateAccountId = (value) => {
    const newId = parseInt(value, 10);
    if (newId === survey.value.account_id) return;

    survey.value.account_id = newId;
    survey.value.contract_id = null;
    useSurveyCreditsStore().requireContractChoice();
  };
  const currentAccount = computed(() =>
    accounts.value?.find((account) => account.id == survey.value?.account_id),
  );
  const canCreateAiChat = computed(() => currentAccount.value?.ai_chat_enabled ?? false);
  const isFreemiumAccount = computed(() => currentAccount.value?.freemium ?? false);

  const accountOptions = computed(
    () =>
      accounts.value
        ?.map((account) => ({ label: accountLabel(account), value: account.id.toString() }))
        .sort((a, b) => a.label.localeCompare(b.label)) || [],
  );

  return {
    currentAccountId,
    updateAccountId,
    accountOptions,
    canCreateAiChat,
    isFreemiumAccount,
  };
});
